module.exports = __webpack_public_path__ + "assets/img/option-empty-image.bba2754f.png";